import React from 'react';
import { ShieldCheckIcon, ArrowRightIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#1A1A2E] py-20 px-6" data-id="element-63">
      <div className="max-w-4xl mx-auto" data-id="element-64">
        <div className="rounded-2xl p-8 sm:p-12 border border-[#4361EE]/20 flex flex-col sm:flex-row items-center gap-8" style={{
        background: 'linear-gradient(135deg, #16213E 0%, #0F3460 100%)'
      }} data-id="element-65">
          {/* Shield icon */}
          <div className="flex-shrink-0" data-id="element-66">
            <div className="w-28 h-28 rounded-full flex items-center justify-center glow-blue" style={{
            background: 'linear-gradient(135deg, #4361EE20, #4361EE10)',
            border: '3px solid #4361EE'
          }} data-id="element-67">
              <ShieldCheckIcon className="w-14 h-14 text-[#4361EE]" data-id="element-68" />
            </div>
          </div>

          {/* Content */}
          <div data-id="element-69">
            <h2 className="text-[#4361EE] text-[48px] sm:text-[60px] leading-none mb-4 glow-text-blue" style={{
            fontFamily: "'Bebas Neue', sans-serif"
          }} data-id="element-70">
              30-DAY MONEY-BACK GUARANTEE
            </h2>
            <p className="text-white/90 text-base leading-relaxed mb-6" style={{
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-71">
              Try ADHD Reset for a full 30 days. If you don't see a measurable
              improvement in your focus, productivity, or ability to finish what
              you start — just email us and we'll refund every penny. No
              questions, no hoops, no hard feelings.
            </p>
            <p className="text-[#A0AEC0] text-sm italic" style={{
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-72">
              "We're so confident this works that we take all the risk. You have
              nothing to lose and a completely different brain to gain."
            </p>

            <button className="mt-6 inline-flex items-center gap-2 bg-[#4361EE] hover:bg-[#3451DE] text-white font-bold px-6 py-3 rounded-xl transition-all duration-200 text-sm uppercase tracking-wide" style={{
            fontFamily: "'Inter', sans-serif"
          }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-73">
              Claim Your Risk-Free Copy
              <ArrowRightIcon className="w-4 h-4" data-id="element-74" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}